import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

@observer
class PageBlockDelete extends Component {
    close = () => {
        const { store } = this.props
        store.pageBlockToEdit = null
        store.pageBlockDeleteConfirm = false
    }

    deleteBlock = () => {
        const { store } = this.props
        const { survey, pageBlockToEdit } = store
        const pageBlockIndex = survey.pageBlocks.findIndex((pb) => pb.id === pageBlockToEdit.id)
        survey.confirmBlockDelete(store, pageBlockIndex)
        this.close()
    }

    render() {
        const { store } = this.props
        return (
            <Modal
                show={store.pageBlockDeleteConfirm}
                onClose={this.close}
                style={{ width: '350px' }}
            >
                <div className="pageHide modal-content survey-modal">
                    <Typography type="h3">
                        {i18n.t('gen_confirm_popup_title')}
                    </Typography>

                    <br />

                    {i18n.t('PageBlockDelete')}

                    <div style={{ marginTop: '15px' }}>
                        <Button
                            className="regular primary"
                            onClick={this.deleteBlock}
                            label={i18n.t('gen_yes')}
                        />

                        <Button
                            className="regular tertiary"
                            onClick={this.close}
                            label={i18n.t('gen_no')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default PageBlockDelete
